import Immutable from 'seamless-immutable';
import _ from 'lodash';
import {
  createField,
  createValidateObject,
  getForm,
  storeSetFieldsErrors,
  storeSetFieldValue
} from '../../../../utils/reducerHalpers/formFields';
import * as validateTypes from '../../../../utils/reducerHalpers/validateTypes';
import {
  createRequestState,
  setRequestStateFinish,
  setRequestStateInProgress
} from '../../../../utils/reducerHalpers/requestState';

const INIT_STATE = 'INIT_STATE';
const REQUEST_IN_PROGRESS = 'REQUEST_IN_PROGRESS';
const REQUEST_FINISHED = 'REQUEST_FINISHED';
const SEND_REQUEST = 'SEND_REQUEST';
const SET_ERRORS = 'SET_ERRORS';
const CLEAR_ALL_ERRORS = 'CLEAR_ALL_ERRORS';
const CHANGE_FIELD_MESSAGE = 'CHANGE_FIELD_MESSAGE';

const reducerName = `execCommentForm`;
const createReducerDotPathName = combineName => `${combineName}.${reducerName}`;

const createActionName = (combineName, name) =>
  `app/${createReducerDotPathName(combineName)}/${name}`;
export const getState = (state, combineName) =>
  _.get(state, createReducerDotPathName(combineName));

const createReducer = name => {
  function stateDefault() {
    return {
      ...createRequestState(),
      fields: {
        ...createField({
          field: 'message',
          title: 'Комментарий',
          value: '',
          validate: [createValidateObject(validateTypes.REQUIRED)],
          errors: []
        })
      }
    };
  }

  const initialState = Immutable(stateDefault());
  return function reduce(state = initialState, action = {}) {
    switch (action.type) {
      case createActionName(name, INIT_STATE):
        return Immutable(stateDefault());
      case createActionName(name, REQUEST_IN_PROGRESS):
        return setRequestStateInProgress(state);
      case createActionName(name, REQUEST_FINISHED):
        return setRequestStateFinish(
          state,
          action.payload.codeResponse,
          action.payload.hasSuccess
        );
      case createActionName(name, SEND_REQUEST):
        return state;
      case createActionName(name, SET_ERRORS):
        return storeSetFieldsErrors(state, action.payload);
      case createActionName(name, CLEAR_ALL_ERRORS):
        return state.merge({
          errors: {}
        });

      // FIELDS
      case createActionName(name, CHANGE_FIELD_MESSAGE): {
        return storeSetFieldValue(state, 'message', action.payload);
      }
      default:
        return state;
    }
  };
};

export function createReduceObject(parentName) {
  const reduceObject = {};
  reduceObject[reducerName] = createReducer(parentName);
  return reduceObject;
}

// ACTIONS CREATOR
export const initState = parentName => ({
  type: createActionName(parentName, INIT_STATE)
});
export const requestInProcess = parentName => ({
  type: createActionName(parentName, REQUEST_IN_PROGRESS)
});
export const requestFinished = (parentName, codeResponse, hasSuccess) => ({
  type: createActionName(parentName, REQUEST_FINISHED),
  payload: { codeResponse, hasSuccess }
});
export const sendRequest = (parentName, payload) => ({
  type: createActionName(parentName, SEND_REQUEST),
  payload
});
export const setErrors = (parentName, payload) => ({
  type: createActionName(parentName, SET_ERRORS),
  payload
});
export const clearAllErrors = (parentName, payload) => ({
  type: createActionName(parentName, CLEAR_ALL_ERRORS),
  payload
});

export const changeFieldMessage = (parentName, payload) => ({
  type: createActionName(parentName, CHANGE_FIELD_MESSAGE),
  payload
});

// SELECTORS
export const selectFormBody = (state, parentName) =>
  getForm(getState(state, parentName));
export const selectRequestState = (state, parentName) =>
  _.get(getState(state, parentName), 'requestState');
export const selectFieldMessage = (state, parentName) =>
  _.get(getState(state, parentName), 'fields.message');



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/tasks/common/reducers/execCommentForm.js